export const convertEntityValuesToFormValues = <FormValues, Entity>(formInitialValues: FormValues, entity: Entity) =>
  Object.keys(formInitialValues).reduce((formData, initialValuesKey) => {
    if (entity[initialValuesKey]) {
      formData[initialValuesKey] = entity[initialValuesKey]
    }

    return formData
  }, {} as FormValues)
